import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function ShareTrackingButton({ orderNo }) {
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState(null);
  const [copied, setCopied] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${orderNo}/share`);
      // Always rebuild URL from current origin so it works in any env
      const base = window.location.origin;
      const publicUrl = `${base}/track/${data.token}`;
      setLink({ url: publicUrl, expires_at: data.expires_at });
      // Copy to clipboard immediately
      try {
        await navigator.clipboard.writeText(publicUrl);
        setCopied(true);
        toast.success("Link copied! Valid for 48 hours.");
      } catch {
        toast.info("Link ready — copy below.");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not generate link.");
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    if (!link) return;
    await navigator.clipboard.writeText(link.url);
    setCopied(true);
    toast.success("Copied.");
  };

  const whatsappMessage = link
    ? `Track my JewelleryOnWheels order live → ${link.url}`
    : "";

  if (!link) {
    return (
      <button
        onClick={generate}
        disabled={busy}
        className="btn-secondary-jow text-[11px]"
        data-testid="share-tracking-btn"
      >
        <Share2 size={13} /> {busy ? "Generating…" : "Share live tracking"}
      </button>
    );
  }

  return (
    <div
      className="bg-jow-cream border border-jow-gold/60 p-4 space-y-3 max-w-md"
      data-testid="share-panel"
    >
      <div>
        <p className="label-overline text-jow-navy">Shareable link</p>
        <p className="text-[10px] text-jow-navy/55 mt-0.5">
          Valid until {new Date(link.expires_at).toLocaleString()} · No PII exposed
        </p>
      </div>
      <div className="flex items-center gap-2">
        <input
          readOnly
          value={link.url}
          onFocus={(e) => e.currentTarget.select()}
          className="flex-1 bg-white border border-jow-navy/15 px-3 py-2 text-xs font-mono"
          data-testid="share-link-input"
        />
        <button
          onClick={copy}
          className="btn-primary-jow text-[11px]"
          data-testid="copy-link-btn"
        >
          {copied ? <Check size={12} /> : <Copy size={12} />}
        </button>
      </div>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary-jow text-[11px] w-full justify-center bg-[#25D366] border-[#25D366] text-white"
        data-testid="whatsapp-share-btn"
      >
        <Share2 size={13} /> Share on WhatsApp
      </a>
    </div>
  );
}
